<template lang="html">
  <div>

    <section class="idioma">
      <label for="idioma">{{ $t('cv.idioma') }}:</label>
      <select :value="lang" @change="selectLang">
        <option value="en">{{ $t('idiomas.en') }}</option>
        <option value="es">{{ $t('idiomas.es') }}</option>
      </select>
    </section>

    <div class="cover-popup row-center" v-if="langselected">
      <div class="popup">
        <p>{{ $t('popup_idioma.titulo') }}</p>
        <div class="contenedor-botones row-center">
          <button @click="requestLangChange" class="btn -solid-primary">{{ $t('registro.si') }}</button>
          <button @click="langselected = ''" class="btn -skull-primary">{{ $t('registro.no') }}</button>
        </div>
      </div>
    </div>

  </div>

</template>

<script lang="js">

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'idioma',
  data: () => ({
    show: false,
    langselected: ''
  }),
  methods: {
    ...mapActions(['changeLanguage']),
    selectLang(event) {
      const selectedLang = event.target.value;
      this.langselected = (selectedLang != this.lang) ? selectedLang : '';
    },
    requestLangChange() {
      this.changeLanguage(this.langselected).then(() => {
        this.langselected = '';
        this.show = false;
      });
    },
  },
  computed: {
    ...mapGetters({
      lang: 'getLanguage'
    })
  }
}
</script>

<style scoped lang="scss">
.idioma {

  display: flex;
  position: relative;

  label {
    font-weight: bold;
    font-size: 20px;
    margin-right: 10px;
  }

  select {
    appearance: none;
    border: none;
    color: inherit;
    font: inherit;
   font-size: 20px;
    cursor: pointer;
    background: url(/static/img/icons/down-arrow.svg) center right/10px no-repeat;
    padding-right: 14px;
    text-align: left;
    font-weight: 600;
  }

}


.popup {
  min-height: 150px;
}

.popup p {
  width: 100%;
  text-align: left;
  font-weight: bold;
  color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/parts/idioma-header.vue